import fs from 'fs';
import Path from 'path';
import templates from './templates';
import thinkit from 'thinkit/lib/index';
import ModuleManager from './module-manager';
import BundleEntry from './bundle-entry';


export default class ChunkBundle extends BundleEntry {
  handleCreate(module) {
    this.modules[module.id] = module;
    this._writeContent(templates.chunk(module));
  }

  _getOutputPath() {
    var p = Path.join('output', this.rootModule.chunkFilename.replace(/^\[chunkId\]$/, this.rootModule.chunkId));
    return p;
  }

  handleAfter() {
    var module = this.rootModule;
    var missingModules = ModuleManager.checkDependencies(module);
    var content = '';
    var errorMessage = missingModules.map(e=>`\n Error: Couldn\'t found dependency "${e.dep.filePath}" in file "${e.module.filePath}, module id is ${e.module.id}".`).join();
    if(errorMessage) {
      content += templates.run(`console.error(${JSON.stringify(errorMessage)});`);
    }
    this._appendContent(content + templates.chunksReady(module));
  }
}